export default defineComponent({
  props: {
    value: {
      type: Boolean,
      required: true
    }
  }
});